import React from 'react';
import {
  CheckCircleIcon,
  SyncIcon,
  WarningIcon,
  InfoIcon,
  LocationOnIcon,
  PersonIcon,
  ScheduleIcon,
  AttachMoneyIcon,
  HomeIcon,
  DescriptionIcon,
  CalendarTodayIcon,
  EventIcon,
  NotificationImportantIcon,
} from '@/shared/ui/display/EmojiIcon';

/**
 * 세션 아이콘 타입
 */
export type SessionIconType =
  | 'check'
  | 'sync'
  | 'warning'
  | 'info'
  | 'document'
  | 'hubspot'
  | 'calendar'
  | 'event'
  | 'notification'
  | string; // 확장 가능

/**
 * 필드 아이콘 타입
 */
export type FieldIconType = 'location' | 'person' | 'schedule' | 'money' | 'area' | 'home' | string; // 확장 가능

/**
 * 세션 아이콘 타입을 React 컴포넌트로 매핑
 */
const sessionIconMap: Record<string, React.ComponentType<any>> = {
  check: CheckCircleIcon,
  sync: SyncIcon,
  warning: WarningIcon,
  info: InfoIcon,
  document: DescriptionIcon,
  hubspot: SyncIcon, // Hubspot 아이콘은 별도로 처리 필요
  calendar: CalendarTodayIcon,
  event: EventIcon,
  notification: NotificationImportantIcon,
};

/**
 * 필드 아이콘 타입을 React 컴포넌트로 매핑
 */
const fieldIconMap: Record<string, React.ComponentType<any>> = {
  location: LocationOnIcon,
  person: PersonIcon,
  schedule: ScheduleIcon,
  money: AttachMoneyIcon,
  area: HomeIcon,
  home: HomeIcon,
};

/**
 * 세션 아이콘 타입으로부터 React 컴포넌트를 반환
 *
 * @param iconType 아이콘 타입 식별자
 * @returns React 컴포넌트 또는 null
 */
export function getSessionIcon(iconType: string): React.ComponentType<any> | null {
  return sessionIconMap[iconType] || null;
}

/**
 * 필드 아이콘 타입으로부터 React 컴포넌트를 반환
 *
 * @param iconType 아이콘 타입 식별자
 * @returns React 컴포넌트 또는 null
 */
export function getFieldIcon(iconType: string): React.ComponentType<any> | null {
  return fieldIconMap[iconType] || null;
}

/**
 * 커스텀 아이콘 매핑 등록
 *
 * @param iconType 아이콘 타입 식별자
 * @param IconComponent React 아이콘 컴포넌트
 */
export function registerSessionIcon(
  iconType: string,
  IconComponent: React.ComponentType<any>
): void {
  sessionIconMap[iconType] = IconComponent;
}

/**
 * 커스텀 필드 아이콘 매핑 등록
 *
 * @param iconType 아이콘 타입 식별자
 * @param IconComponent React 아이콘 컴포넌트
 */
export function registerFieldIcon(iconType: string, IconComponent: React.ComponentType<any>): void {
  fieldIconMap[iconType] = IconComponent;
}
